import _ from 'lodash';
import api from '../../../api';
import moment from 'moment';
import numeral from 'numeral';
import DataTable from '../../../core/charts/Datatable';
import translate from '../../../core/tools/translate';
import environment from '../../../environment';
import { FeaturePermission } from '../../../../constants/feature.permission.helper';
import { CountryEnum } from '../../../../enuns/country.enum';
import { VehicleTypeEnum } from '../../../core/vehicleType/constants';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const _hasFullSummaryAccess = () => {
    const sales_type = environment.get('CONFIG').FILTERS.SALES_TYPE;
    return _.find(sales_type, ['value', 1] || _.find(sales_type, ['value', 3]));
};

const Anothers = 'Outros';

const reducers = {
    location(res, req) {
        const isPremium = environment.get('CONFIG.IS_PREMIUM');

        if (!_.size(res) || res.demografia.Populacao === 0) {
            console.error('ERROR: empty response for summary request');
            return null;
        }

        const output = {};

        output.isSummaryComplete = _hasFullSummaryAccess();

        if (req.locations) {
            output.locations = req.locations;
        }

        const _generateTemplate = (data, name, percent) => {
            const template = {
                title: translate(`Summary.${name}`),
                values: []
            };
            _.forEach(data, (value, key) => {
                if (!_.isNumber(value)) {
                    value = 0;
                }

                template.values.push({
                    label: (() => {
                        switch (name) {
                            case 'Automakers':
                                if (key === 'LojasBandeira') {
                                    return environment.get('CONFIG.CLIENT');
                                } else {
                                    return key;
                                }

                            default:
                                return translate(`Summary.${_.upperFirst(key)}`);
                        }
                    })(),
                    value:
                        key === 'DomiciliosTarget' || percent
                            ? numeral(value / 100).format('0,0.0%')
                            : numeral(value).format('0,0')
                });
            });
            return template;
        };

        const _calculateDemographyGrid = format =>
            _.forEach(output.demography.values, (row, index) => {
                if (format === 1) {
                    output.demography.values[index].size = 6;
                } else if (format === 2 && index < 2) {
                    output.demography.values[index].size = 6;
                } else {
                    output.demography.values[index].size = 4;
                }
            });

        if (_.size(res.emplacamentoMedioMensal)) {
            let data = [];
            let segment = false;

            const total = {};
            const brand = environment.get('CONFIG.CLIENT');

            const types = {
                Bandeira: 'Brand',
                Segmento: 'Segment',
                Indústria: 'Industry',
                'Indústria Premium': 'PremiumIndustry',
                'Selected Brands': 'CompetingBrands',
                'Selected Products': 'CompetingProducts'
            };

            _.forEach(res.emplacamentoMedioMensal, sales => {
                if (sales.tipo === 'Segmento') {
                    segment = true;
                }

                _.forEach(sales.valores, value => {
                    if (!total[value.ano]) {
                        total[value.ano] = {};
                    }

                    if (segment) {
                        total[value.ano][translate(`Summary.${types[sales.tipo]}`)] =
                            total[value.ano][brand] - Number(value.valor);
                    }

                    total[value.ano][translate(`Summary.${types[sales.tipo]}`)] = Number(value.valor);
                });
            });

            output.performance = { title: translate('Common.MonthlyAverageRegistration') };

            data = [];
            _.forEach(total, (val, year) =>
                _.forEach(val, (value, type) => {
                    if (type === translate('Common.Segment')) {
                        type = environment.get('CONFIG.MAIN_SEGMENT');
                    }
                    const sales = {};
                    sales[translate('Common.Type')] = type;
                    sales.Total = Math.round(value);
                    sales[translate('Common.Year')] = year;
                    data.push(sales);
                })
            );

            data = _.filter(
                data,
                d =>
                    !_.some(
                        [
                            translate('Summary.PremiumIndustry'),
                            isPremium ? translate('Summary.Industry') : translate('Summary.CompetingProducts'),
                            translate('Summary.CompetingBrands')
                        ],
                        t => d[translate('Common.Type')] === t
                    )
            );
            output.performance.chart = new DataTable(data, {
                row: translate('Common.Type'),
                column: translate('Common.Year'),
                value: 'Total',
                exclude: [brand, environment.get('CONFIG.MAIN_SEGMENT')]
            });

            if (segment) {
                output.performance.chart.setOptions({ exclude: [brand, translate('Summary.Industry')] });
                output.performance.chart.add(data);
            } else {
                output.performance.chart.setOptions({
                    exclude: [
                        isPremium ? translate('Summary.CompetingProducts') : translate('Summary.Industry'),
                        environment.get('CONFIG.MAIN_SEGMENT')
                    ]
                });
                output.performance.chart.add(data);
            }

            const years = Object.keys(total).sort();

            data = [];
            _.forEach(years, period =>
                _.forEach(total, (val, year) => {
                    if (year !== period) {
                        return;
                    }

                    const factor =
                        parseInt(moment(req.endDate, 'YYYYMM').format('MM')) -
                        parseInt(moment(req.startDate, 'YYYYMM').format('MM')) +
                        1;
                    const sales = { [translate('Common.Year')]: year };

                    _.forEach(val, (value, type) => {
                        if (type === translate('Common.Segment')) {
                            type = environment.get('CONFIG.MAIN_SEGMENT');
                        }

                        sales[`${type}`] = (() => {
                            try {
                                return numeral(value * factor).format('0,0');
                            } catch (err) {
                                console.log(err);
                                return 0;
                            }
                        })();

                        sales[`MME ${type}`] = value;

                        if (
                            _.some(
                                [
                                    translate('Summary.Industry'),
                                    translate('Summary.PremiumIndustry'),
                                    translate('Summary.CompetingBrands'),
                                    translate('Summary.CompetingProducts')
                                ],
                                t => t === type
                            )
                        ) {
                            sales[`MS ${type}`] = (() => {
                                try {
                                    return numeral((value - total[year][brand]) / value).format('0.00%');
                                } catch (err) {
                                    console.log(err);
                                    return 0;
                                }
                            })();
                        } else {
                            sales[`MS ${type}`] = (() => {
                                try {
                                    return numeral(value / total[year][translate('Summary.Industry')]).format('0.00%');
                                } catch (err) {
                                    console.log(err);
                                    return 0;
                                }
                            })();

                            if (isPremium) {
                                sales[`MS ${type} (${translate('Summary.PremiumIndustry')})`] = (() => {
                                    try {
                                        return numeral(value / total[year][translate('Summary.PremiumIndustry')]).format('0.00%');
                                    } catch (err) {
                                        console.log(err);
                                        return 0;
                                    }
                                })();
                            }

                            if (isPremium && _.toUpper(type) === _.toUpper(brand)) {
                                sales[`MS ${type} (${translate('Summary.CompetingProducts')})`] = (() => {
                                    try {
                                        return numeral(
                                            value / total[year][translate('Summary.CompetingProducts')]
                                        ).format('0.00%');
                                    } catch (err) {
                                        console.log(err);
                                        return 0;
                                    }
                                })();
                            }
                        }

                        if (years.contains(String(+year - 1))) {
                            sales[`VAR ${type}`] = (() => {
                                try {
                                    return numeral(value / total[+year - 1][type] - 1).format('0.00%');
                                } catch (err) {
                                    console.log(err);
                                    return 0;
                                }
                            })();
                        } else {
                            sales[`VAR ${type}`] = '-';
                        }
                    });

                    return data.push(sales);
                })
            );

            let row = [];

            let prefix;

            switch (environment.get("CONFIG.USERVEHICLETYPE")) {
                case VehicleTypeEnum.Car:
                    prefix = translate('Help.PrefixCar');
                    break;
                case VehicleTypeEnum.Moto:
                    prefix = translate('Help.PrefixMotorcycle');
                    break;
                case VehicleTypeEnum.Truck:
                    prefix = translate('Help.PrefixTrucks');
                    break;
                default:
                    prefix = "";
            }

            const withPrefix = (...parts) => _.filter(parts, x => x).join(' ');

            const help = {
                [translate('Summary.Industry')]: withPrefix(translate('Help.TotalIndustryRegistration'), prefix, translate('Help.AllBrands')),
                [brand]: withPrefix(translate('Help.TotalBrandsRegistration'), prefix),
                [`MS ${brand}`]: translate('Help.TotalBrandsMarketShare', { bandeira: brand }),
                [`MS ${brand} (${translate('Summary.PremiumIndustry')})`]: translate('Help.TotalBrandsPremiumMarketShare', {
                    bandeira: brand
                }),
                [`MS ${brand} (${translate('Summary.CompetingProducts')})`]: translate(
                    'Help.TotalBrandsMarketShareOverCompetitors',
                    { bandeira: brand }
                ),
                [`VAR ${brand}`]: translate('Help.TotalBrandsVariation', { bandeira: brand }),
                [`MS ${translate('Summary.Industry')}`]: translate('Help.TotalIndustryMarketShare'),
                [`VAR ${translate('Summary.Industry')}`]: translate('Help.TotalIndustryVariation'),
                [translate('Summary.CompetingBrands')]: withPrefix(translate('Help.TotalCompetingBrands'), prefix),
                [translate('Summary.CompetingProducts')]: withPrefix(translate('Help.TotalCompetingProducts'), prefix, translate('Help.AllBrands')),
                [translate('Summary.PremiumIndustry')]: withPrefix(translate('Help.TotalPremiumIndustry'), prefix, translate('Help.AllBrands')),
            };

            if (_.some(res.emplacamentoMedioMensal, x => x.tipo === 'Indústria')) {
                row.push(
                    // "MME #{brand}"
                    // "MME Indústria"
                    translate('Summary.Industry'),
                    `VAR ${translate('Summary.Industry')}`
                    // `TOTAL ${brand}`,
                    // `VAR ${brand}`,
                    // `MS ${brand}`,
                    // `MS ${translate('Summary.Industry')}`
                );
            }

            if (isPremium) {
                row.splice(1, 1);
                _.forEach(
                    [
                        translate('Summary.PremiumIndustry'),
                        translate('Summary.CompetingProducts')
                    ],
                    t => {
                        row.push(`${t}`);
                    }
                );
            }

            if (segment) {
                const text = environment.get('CONFIG.MAIN_SEGMENT');
                row.push(`${text}`, `VAR ${text}`, `MS ${text}`);
            } else if (_.some(res.emplacamentoMedioMensal, x => x.tipo === 'Indústria')) {
                row.push(`${brand}`, `VAR ${brand}`);
            } else {
                row.push(`${brand}`, `VAR ${brand}`);
            }

            if (!isPremium) {
                if (_.some(res.emplacamentoMedioMensal, x => x.tipo === 'Indústria')) {
                    row.push(`MS ${brand}`);
                }
            }

            if (isPremium) {
                if (_.some(res.emplacamentoMedioMensal, x => x.tipo === 'Indústria')) {
                    row.push(`MS ${brand} (${translate('Summary.PremiumIndustry')})`);
                }

                row.push(`MS ${brand} (${translate('Summary.CompetingProducts')})`);
            }

            if (_.toUpper(brand) === 'JEEP') {
                row = row.filter(
                    r =>
                        !_.some(
                            [translate('Summary.PremiumIndustry'), translate('Summary.CompetingBrands')],
                            k => k === r
                        )
                );
            }

            output.evaluation = {
                table: {
                    dataSource: _.reduce(
                        row,
                        (acc, key) => {
                            const r = {
                                indicator: key,
                                help: help[key]
                            };
                            _.forEach(data, d => {
                                r[`_${d[translate('Common.Year')]}`] = d[key];
                            });
                            acc.push(r);
                            return acc;
                        },
                        []
                    ),
                    columns: [
                        {
                            field: 'indicator',
                            title: translate('Common.Year'),
                            template: data =>
                                kendo.template('<span title="#=data.help#">#=data.indicator#</span>')(data)
                        },
                        ..._.map(years, y => ({
                            field: `_${String(y)}`,
                            title: y
                        }))
                    ]
                }
            };
        }

        //TODO: better solution is create a permission.
        // if (res.demografia && res.demografia.quantidadeDomiciliosTarget > 0 && environment.get('CONFIG.USERVEHICLETYPE') !== VehicleTypeEnum.Truck) {
        if (isAuthorized(FeaturePermission.INFO_SUMMARY.showDemography)) {
            const keyIndustryIPC = {
                [VehicleTypeEnum.Car]: 'IndustryIPCAuto',
                [VehicleTypeEnum.Moto]: 'IndustryIPCMoto',
                [VehicleTypeEnum.Truck]: 'IndustryIPCTruck'
            };

            if (_.size(res.ipc)) {
                res.demografia[keyIndustryIPC[environment.get('CONFIG.USERVEHICLETYPE')]] = res.ipc.industria;
            }

            output.demography = _generateTemplate(res.demografia, 'Demography');
            switch (output.demography.values.length % 3) {
                case 0:
                    _calculateDemographyGrid(0);
                    break;
                case 1:
                    _calculateDemographyGrid(1);
                    break;
                case 2:
                    _calculateDemographyGrid(2);
                    break;
            }
        }

        if (_.size(res.indicadoresCustomizados)) {
            const values = [];
            _.forEach(res.indicadoresCustomizados, value => {
                const data = {
                    label: translate(`${value.nome}`),
                    value: value.total
                };

                // if (value.nome === 'CPUS')
                //  data.hint = translate('Common.CPUSHint')
                return values.push(data);
            });

            output.indicators = {
                title: translate('Common.BrandsIndicators'),
                values
            };
        }

        if (_.size(res.distribuidores)) {
            const formatDataSource = values => {
                const doc = {};
                _.forEach(values, (val, key) => {
                    doc[key] = val;
                });

                return doc;
            };

            let dataSource = {
                data: _(res.distribuidores)
                    .filter(values => !_.some(['Total'], s => values.nome === s))
                    .map(formatDataSource, {})
                    .value()
            };

            const dealerName = environment.get('CONFIG.CLIENT');
            const hasNeedAcceptTermsUse = environment.get('CONFIG.HASNEEDACCEPTTERMSUSE');
            const hasAcceptTermsUse = environment.get('CONFIG.HASACCEPTTERMSUSE');
            output.automakers = {
                isLegalTextVisible: (hasNeedAcceptTermsUse && hasAcceptTermsUse) ? true : false,
                legalText: translate('Help.LegalText').replace('${dealerName}', dealerName),
                title: translate('Common.Automakers'),
                values: _.map(res.distribuidores, m => ({
                    name: m.nome,
                    total: m.total,
                    groups: m.grupos,
                    stores: m.concessionarias,
                    showrooms: m.showrooms,
                    workshops: m.oficinas,
                    pdas: m.pdas,
                    salesEfficiency: (() => {
                        if (m.eficiencia) {
                            return m.nome === 'Total' ? '-' : numeral(m.eficiencia).format('0,0');
                        }

                        return '-';
                    })()
                })),
                chart: {
                    dataSource,
                    sortable: true,
                    columns: [
                        {
                            field: 'nome',
                            title: translate('Common.AutomakerName'),
                            footerTemplate: 'Total',
                            locked: true,
                            lockable: false,
                            width: 80
                        },
                        {
                            field: 'grupos',
                            title: translate('Common.Groups'),
                            template: data => numeral(data.grupos).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.nome === 'Total').grupos).format('0,0'))(
                                    res.distribuidores
                                ),
                            width: 80
                        },
                        {
                            field: 'total',
                            title: translate('Common.TotalStores'),
                            template: data => numeral(data.total).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.nome === 'Total').total).format('0,0'))(res.distribuidores),
                            width: 80
                        },
                        {
                            field: 'concessionarias',
                            title: translate('Concessionária Completa'),
                            template: data => numeral(data.concessionarias).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.nome === 'Total').concessionarias).format('0,0'))(res.distribuidores),
                            width: 80
                        },
                        {
                            field: 'showrooms',
                            title: translate('Showroom'),
                            template: data => numeral(data.showrooms).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.nome === 'Total').showrooms).format('0,0'))(
                                    res.distribuidores
                                ),
                            width: 80
                        },
                        {
                            field: 'oficinas',
                            title: translate('Common.Services'),
                            template: data => numeral(data.oficinas).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.nome === 'Total').oficinas).format('0,0'))(
                                    res.distribuidores
                                ),
                            width: 80
                        },
                    ]
                }
            };

            if (window.NeoGIG.country === CountryEnum.Argentina) {
                output.automakers.chart.columns.push({
                    field: 'pdas',
                    visible: false,
                    title: translate('Pda'),
                    template: data => numeral(data.pdas).format('0,0'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.nome === 'Total').pdas).format('0,0'))(
                            res.distribuidores
                        ),
                    width: 80
                });
            }

            output.automakers.chart.columns.push({
                field: 'eficiencia',
                title: translate('Common.Throughput'),
                template: data => numeral(data.eficiencia).format('0,0[.]00'),
                footerTemplate: (data =>
                    numeral(_.find(data, r => r.nome === 'Total').eficiencia).format('0,0[.]00'))(
                        res.distribuidores
                    ),
                width: 100
            }
            );
        }

        if (_.size(res.rankingMontadoras)) {
            output.ranking = { title: translate('Common.Ranking') };

            let dataSource = {
                data: _(res.rankingMontadoras)
                    .filter(values => !_.some([Anothers], s => values.montadora === s))
                    .map(value => {
                        value.varejo = value.varejo / 100;
                        value.vendaDireta = value.vendaDireta / 100;
                        value.total = value.total / 100;
                        return value;
                    })
                    .value()
            };

            output.ranking = { title: translate('Common.Ranking') };
            output.ranking.chart = {
                dataSource,
                sortable: true,
                columns: [
                    {
                        field: 'montadora',
                        title: translate('Common.Brand'),
                        footerTemplate: isPremium ? '' : translate('Common.Others')
                    },
                    {
                        field: 'varejo',
                        title: translate('Common.Retail'),
                        template: data => numeral(data.varejo).format("0,0.0%"),
                        footerTemplate: isPremium
                            ? ''
                            : (d =>
                                numeral((_.find(d, r => r.montadora === Anothers) || {}).varejo / 100).format(
                                    '0,0.0%'
                                ))(res.rankingMontadoras)
                    },
                    {
                        field: 'vendaDireta',
                        title: translate('Common.DirectSalesAcronyms'),
                        template: data => numeral(data.vendaDireta).format("0,0.0%"),
                        footerTemplate: isPremium
                            ? ''
                            : (d =>
                                numeral((_.find(d, r => r.montadora === Anothers) || {}).vendaDireta / 100).format(
                                    '0,0.0%'
                                ))(res.rankingMontadoras)
                    },
                    {
                        field: 'total',
                        title: translate('Common.Total'),
                        template: data => numeral(data.total).format("0,0.0%"),
                        footerTemplate: isPremium
                            ? ''
                            : (d =>
                                numeral((_.find(d, r => r.montadora === Anothers) || {}).total / 100).format(
                                    '0,0.0%'
                                ))(res.rankingMontadoras)
                    }
                ]
            };
        }

        if (_.size(res.emplacamentos) || _.size(res.resultadoPorSegmento)) {
            output.registrations = {
                title: translate('Common.TotalRegistrationsBySegment'),
                values: []
            };

            // Get the categories of the segments and create a dictonary
            const dealer = environment.get('CONFIG.CLIENT');
            const segment = translate('Common.Industry'); // environment.get('CONFIG.CLIENT')
            const categories = {};
            const charts = {};

            const mapDataReport = e => ({
                Varejo: e.varejo,
                VendaDireta: e.vendaDireta,
                Total: e.total
            });

            if (_.size(res.emplacamentos)) {
                _.forEach(res.emplacamentos, e => {
                    if (!e)
                        return;

                    categories[segment] = categories[segment] || {};
                    categories[segment][e.tipo] = mapDataReport(e);
                });
            }

            if (_.size(res.resultadoPorSegmento)) {
                _.forEach(res.resultadoPorSegmento, s => {
                    if (!s)
                        return;

                    categories[s.nomeSegmento] = categories[s.nomeSegmento] || {};
                    _.forEach(s.indicadoresSegmento, i => categories[s.nomeSegmento][i.tipo] = mapDataReport(i));

                    if (!charts[s.nomeSegmento]) {
                        charts[`${s.nomeSegmento}-absolute`] = new DataTable(s.rankingSegmento, {
                            row: ['marketShareAbsoluteValue'],
                            column: 'familiaRankingPositionSegmento'
                        });
                        charts[`${s.nomeSegmento}-percent`] = new DataTable(s.rankingSegmento, {
                            row: ['marketShareRankingPosition'],
                            column: 'familiaRankingPositionSegmento'
                        });
                        charts[`${s.nomeSegmento}-pie`] = new DataTable(s.rankingSegmento, {
                            row: 'familiaRankingPositionSegmento',
                            column: ['marketShareRankingPosition']
                        });
                    }
                });

                if (categories[segment]) {
                    const data = [];
                    _.forEach(categories, (val, key) => {
                        if (key === segment)
                            return;

                        const item = {
                            Segmento: key,
                            [translate('Common.Industry')]: Number(
                                _.find(val, (v, k) => k === 'EmplacamentoTotalSegmento').Total.toFixed(0)
                            )
                        };
                        item[dealer] = Number(_.find(val, (v, k) => k === 'EmplacamentoFamilia').Total.toFixed(0));
                        return data.push(item);
                    });

                    charts[segment] = new DataTable(data, {
                        row: 'Segmento',
                        column: [dealer, translate('Common.Industry')],
                        sort: {
                            field: 'Segmento',
                            reverse: true
                        }
                    });
                }
            }

            // create the template based on the categories
            _.forEach(categories, (val, key) => {
                const isIndustryChart = key === segment;
                const keyPrincipalChart = isIndustryChart ? key : `${key}-absolute`;
                const k = Buffer.from(key).toString('base64').toLowerCase().replace(/=/g, '');

                output.registrations.values.push({
                    chart: charts[keyPrincipalChart],
                    chartPercent: !isIndustryChart && charts[`${key}-percent`],
                    chartPie: !isIndustryChart && charts[`${key}-pie`],
                    tab: `summary-tab-${k}`,
                    title: translate(key),
                    key: k,
                    showGroupBtn: !isIndustryChart,
                    values: (() => {
                        const categoriesValues = [];
                        _.forEach(val, (v, k) => {
                            const percent = (() => {
                                switch (k) {
                                    case 'PercentualSegmentoSobreIndustria':
                                    case 'MarketShareFamilia':
                                    case 'MarketShareBandeira':
                                    case 'MarketShareBandeira importado':
                                        return true;
                                    default:
                                        return false;
                                }
                            })();
                            categoriesValues.push(_generateTemplate(v, k, percent));
                        });

                        return categoriesValues;
                    })()
                });
            });

            let index = _.findIndex(output.registrations.values, { title: translate('Common.Industry') });
            if (index >= 0) {
                let item = output.registrations.values[index];
                output.registrations.values.splice(index, 1);
                output.registrations.values.splice(0, 0, item);

                if (environment.get("CONFIG.CLIENT_TOTAL_SALES")) {
                    const industryCategory = categories[segment];
                    if (industryCategory) {
                        const clientTotal = industryCategory['EmplacamentosBandeira'] ? industryCategory['EmplacamentosBandeira'].Total : 0;
                        const industryTotal = industryCategory['EmplacamentosIndustria'] ? industryCategory['EmplacamentosIndustria'].Total : 0;
                        const marketShare = industryCategory['MarketShareBandeira'] ? industryCategory['MarketShareBandeira'].Total : 0;

                        item.values = [{
                            title: translate('Common.TotalRegistrations'),
                            values: [
                                {
                                    value: numeral(clientTotal).format('0,0'),
                                    label: dealer
                                },
                                {
                                    value: numeral(industryTotal).format('0,0'),
                                    label: translate('Common.Industry')
                                },
                                {
                                    value: numeral(marketShare / 100).format('0,0.0%'),
                                    label: 'Market Share (%)'
                                }
                            ]
                        }];
                    }
                }
            }
        }

        return output;
    },

    marketShareSalesDetails(res) {
        const formatDataSource = values => {
            const doc = {};
            _.forEach(values, (val, key) => {
                if (key === 'referencesMarketShare') {
                    _.forEach(val, (v, k) => {
                        doc[_.snakeCase(k)] = v;
                    });
                } else {
                    doc[key] = val;
                }
            });

            return doc;
        };

        const getValueIcon = (val1, val2) => {
            if (val1 === val2) {
                return '';
            }

            return val1 < val2
                ? '<i class="fa fa-caret-up" style="color: #2ecc71"></i>'
                : '<i class="fa fa-caret-down" style="color: #e74c3c"></i>';
        };

        res = _.map(res, r => ({
            ...r,
            industryPercent: numeral(r.industryValue)
                .divide(_.find(res, t => t.segmentName === "TOTAL").industryValue)
                .value(),
            flagPercent: numeral(r.flagValue)
                .divide(_.find(res, t => t.segmentName === "TOTAL").flagValue)
                .value(),
        }));

        let dataSource = {
            data: _(res)
                .filter(values => !_.some([Anothers, 'TOTAL'], s => values.segmentName === s))
                .map(formatDataSource, {})
                .value()
        };

        let dataFooter = {
            data: _(res).filter(values => values.segmentName === 'TOTAL').map(formatDataSource, {}).value()
        };

        dataSource.data = _.concat(
            dataSource.data,
            _(res)
                .filter(values => values.segmentName === Anothers)
                .map(formatDataSource, {})
                .value()
        );

        return {
            dataSource,
            dataFooter,
            sortable: true,
            columns: [
                {
                    field: 'segmentName',
                    title: translate('Common.Segment'),
                    footerTemplate: 'Total'
                },
                {
                    field: 'industryValue',
                    title: translate('Common.Industry'),
                    template: data => numeral(data.industryValue).format('0,0[.]00'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').industryValue).format('0,0[.]00'))(res)
                },
                {
                    field: 'industryPercent',
                    title: translate('Common.SharePerSegment'),
                    template: data => numeral(data.industryPercent).format('0,0[.]0%'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').industryPercent).format('0,0[.]0%'))(res)
                },
                {
                    field: 'flagValue',
                    title: `${environment.get('CONFIG.CLIENT')}`,
                    template: data => numeral(data.flagValue).format('0,0[.]00'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').flagValue).format('0,0[.]00'))(res)
                },
                {
                    field: 'flagPercent',
                    title: translate('Common.SharePerSegment'),
                    template: data => numeral(data.flagPercent).format('0,0[.]0%'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').flagPercent).format('0,0[.]0%'))(res)
                },
                {
                    field: 'marketShareValue',
                    title: 'Market Share Área (%)',
                    template: data => numeral(data.marketShareValue).format('0,0[.]0%'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').marketShareValue).format('0,0.0%'))(res)
                },
                {
                    title: translate('Common.BrandsMarketShare'),
                    columns: _.map(res[0].referencesMarketShare, (val, key) => ({
                        field: _.snakeCase(key),
                        title: key,
                        template: (k => data =>
                            data[_.snakeCase(k)] > 0
                                ? `${getValueIcon(data.marketShareValue, data[_.snakeCase(k)])} ${numeral(
                                    data[_.snakeCase(k)]
                                ).format('0,0.0%')}`
                                : '-')(key),
                        footerTemplate: ((data, k) =>
                            numeral(_.find(data, r => r.segmentName === 'TOTAL').referencesMarketShare[k]).format(
                                '0,0.0%'
                            ))(res, key)
                    }))
                }
            ]
        };
    },

    invasionIndicator(res) {
        const formatDataSource = values => {
            const doc = {};
            _.forEach(values, (val, key) => {
                doc[key] = val;
            });

            return doc;
        };

        let dataSource = {
            data: _(res)
                .filter(values => !_.some([Anothers, 'TOTAL'], s => values.segmentName === s))
                .map(formatDataSource, {})
                .value()
        };

        let dataFooter = {
            data: _(res).filter(values => values.segmentName === 'TOTAL').map(formatDataSource, {}).value()
        };

        dataSource.data = _.concat(
            dataSource.data,
            _(res)
                .filter(values => values.segmentName === Anothers)
                .map(formatDataSource, {})
                .value()
        );

        return {
            dataSource,
            dataFooter,
            sortable: true,
            columns: [
                {
                    field: 'segmentName',
                    title: translate('Common.Segment'),
                    footerTemplate: 'TOTAL'
                },
                {
                    field: 'ValueBrand',
                    title: `${translate('Common.Registrations')} ${environment.get('CONFIG.CLIENT')}`,
                    template: data => numeral(data.valueBrand).format('0,0[.]00'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').valueBrand).format('0,0[.]00'))(res)
                },
                {
                    field: 'ValueDealers',
                    title: translate('Common.TotalRegistrationsDealers'),
                    template: data => numeral(data.valueDealers).format('0,0[.]00'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').valueDealers).format('0,0[.]00'))(res)
                },
                {
                    field: 'ValueAnotherDealers',
                    title: translate('Common.TotalRegistrationsAnotherDealers'),
                    template: data => numeral(data.valueAnotherDealers).format('0,0[.]00'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').valueAnotherDealers).format('0,0[.]00'))(res)
                },
                {
                    field: 'ValueInvasion',
                    title: `${translate('Common.Invasion')} (%)`,
                    template: data => numeral(data.valueInvasion).format('0,0[.]00%'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.segmentName === 'TOTAL').valueInvasion).format('0,0.00%'))(res)
                }
            ]
        };
    },

    ipcAutoDeatail(res) {
        const formatDataSource = values => {
            const doc = {};
            _.forEach(values, (val, key) => {
                doc[key] = val;
            });

            return doc;
        };

        let dataSource = {
            data: _(res)
                .filter(values => !_.some(['TOTAL'], s => values.descricao === s))
                .map(formatDataSource, {})
                .value()
        };

        return {
            dataSource,
            sortable: true,
            columns: [
                {
                    field: 'descricao',
                    title: 'Target',
                    footerTemplate: 'Total'
                },
                {
                    field: 'vr_Referencia',
                    title: translate('Common.Households'),
                    template: data => numeral(data.vr_Referencia).format('0,0'),
                    footerTemplate: (data =>
                        numeral(_.find(data, r => r.descricao === 'TOTAL').vr_Referencia).format('0,0'))(res)
                },
                {
                    title: translate('Common.Retail'),
                    columns: [
                        {
                            field: 'emp_Varejo',
                            title: translate('Common.Registrations'),
                            template: data => numeral(data.emp_Varejo).format('0,0[.]00'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').emp_Varejo).format('0,0[.]00'))(res)
                        },
                        {
                            field: 'ref_Varejo',
                            title: 'IPC Auto',
                            template: data => numeral(data.ref_Varejo).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').ref_Varejo).format('0,0'))(res)
                        }
                    ]
                },
                {
                    title: translate('DirectSales.'),
                    columns: [
                        {
                            field: 'emp_Direta',
                            title: translate('Common.Registrations'),
                            template: data => numeral(data.emp_Direta).format('0,0[.]00'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').emp_Direta).format('0,0[.]00'))(res)
                        },
                        {
                            field: 'ref_Direta',
                            title: 'IPC Auto',
                            template: data => numeral(data.ref_Direta).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').ref_Direta).format('0,0'))(res)
                        }
                    ]
                },
                {
                    title: 'Total',
                    columns: [
                        {
                            field: 'emp_Industria',
                            title: translate('Common.Registrations'),
                            template: data => numeral(data.emp_Industria).format('0,0[.]00'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').emp_Industria).format('0,0[.]00'))(
                                    res
                                )
                        },
                        {
                            field: 'ref_Industria',
                            title: 'IPC Auto',
                            template: data => numeral(data.ref_Industria).format('0,0'),
                            footerTemplate: (data =>
                                numeral(_.find(data, r => r.descricao === 'TOTAL').ref_Industria).format('0,0'))(res)
                        }
                    ]
                }
            ]
        };
    },

    period(res) {
        let start = moment()
            .startOf('year')
            .toDate();
        let end = moment().toDate();

        if (res && res.dataInicial) {
            start = moment(res.dataInicial).toDate();
        }

        if (res && res.dataFinal) {
            end = moment(res.dataFinal).toDate();
        }

        return { start, end };
    },

    marketShare(res, req) {
        const years = _(res.result)
            .map(d => d.ANO)
            .uniq()
            .sort()
            .reverse()
            .value();

        const sales = (() => {
            const doc = {
                dealerships: 'LOJA_COMPLETA',
                carServices: 'LOJA_OFICINA',
                showrooms: 'LOJA_SHOWROOM',
                groups: 'QT_GRUPO'
            };
            switch (req.sales) {
                case 'retail':
                    return _.assign({}, doc, {
                        qtd: 'VENDA_VAREJO',
                        msa: 'PERC_VENDA_VAREJO_AREA',
                        msn: 'PERC_VENDA_VAREJO_NAC'
                    });
                case 'direct':
                    return _.assign({}, doc, {
                        qtd: 'VENDA_DIRETA',
                        msa: 'PERC_VENDA_DIRETA_AREA',
                        msn: 'PERC_VENDA_DIRETA_NAC'
                    });
                default:
                    return _.assign({}, doc, { qtd: 'VOLUME', msa: 'PERC_VENDA_AREA', msn: 'PERC_VENDA_NAC' });
            }
        })();

        const data = {
            values: _(res.result)
                .groupBy('NOME_BANDEIRA')
                .reduce((r, v, k) => {
                    const row = {
                        ranking: _.size(r) + 1,
                        brand: String(k)
                    };

                    _.forEach(years, year => {
                        const val = _.find(v, j => j.ANO === year);
                        if (val) {
                            const salesShowroom = val[sales.dealerships] + val[sales.showrooms];

                            row['outlets_' + val.ANO] =
                                val[sales.dealerships] + val[sales.showrooms] + val[sales.carServices];
                            row['dealerships_' + val.ANO] = val[sales.dealerships];
                            row['car_services_' + val.ANO] = val[sales.carServices];
                            row['showrooms_' + val.ANO] = val[sales.showrooms];
                            row['groups_' + val.ANO] = val[sales.groups];
                            row['volume_' + val.ANO] = val[sales.qtd];
                            row['sales_efficiency_' + val.ANO] = salesShowroom ? val[sales.qtd] / salesShowroom : 0;
                            row['area_' + val.ANO] = val[sales.msa] / 100;
                            row['national_' + val.ANO] = val[sales.msn] / 100;
                        } else {
                            row['outlets_' + year] = 0;
                            row['dealerships_' + year] = 0;
                            row['car_services_' + year] = 0;
                            row['showrooms_' + year] = 0;
                            row['outlets_' + year] = 0;
                            row['volume_' + year] = 0;
                            row['sales_efficiency_' + year] = 0;
                            row['area_' + year] = 0;
                            row['national_' + year] = 0;
                        }
                    });
                    r.push(row);
                    return r;
                }, []),

            aggregate: _(res.result)
                .groupBy('NOME_BANDEIRA')
                .reduce((r, v, k) => {
                    const row = [];
                    _.forEach(v, val => {
                        row.push({ field: `dealerships_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `car_services_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `showrooms_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `outlets_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `groups_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `volume_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `area_${val.ANO}`, aggregate: 'sum' });
                        row.push({ field: `national_${val.ANO}`, aggregate: 'sum' });
                    });

                    r = _.concat(r, row);
                    return r;
                }, [])
        };

        const output = {
            dataSource: {
                data: _.filter(data.values, d => _.upperCase(d.brand) !== 'TOTAL'),
                aggregate: data.aggregate
            },
            columns: [
                {
                    field: 'ranking',
                    title: 'Ranking',
                    locked: true,
                    lockable: false,
                    width: 60
                },
                {
                    field: 'brand',
                    title: translate('Common.Brands'),
                    footerTemplate: 'Total',
                    locked: true,
                    lockable: false,
                    width: 160
                }
            ]
        };

        output.columns = _.concat(
            output.columns,
            _.map(years, date => ({
                title: (() => {
                    let firstMonth;
                    let lastMonth;

                    if (res.partial) {
                        firstMonth = moment(req.startDate, 'YYYYMM').format('MMM');
                        lastMonth = moment(req.endDate, 'YYYYMM').format('MMM');
                    } else {
                        firstMonth = moment()
                            .startOf('year')
                            .format('MMM');
                        if (
                            date ===
                            moment(req.endDate, 'YYYYMM')
                                .toDate()
                                .getFullYear()
                        ) {
                            lastMonth = moment(req.endDate, 'YYYYMM').format('MMM');
                        } else {
                            lastMonth = moment()
                                .endOf('year')
                                .format('MMM');
                        }
                    }

                    return `${date} ┆ ${firstMonth} - ${lastMonth}`;
                })(),

                columns: [
                    {
                        title: 'A',
                        columns: [
                            {
                                field: `dealerships_${date}`,
                                title: 'Completa',
                                template: (dt => dataItem => numeral(dataItem[`dealerships_${dt}`]).format('0,0[.]00'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][
                                        `dealerships_${dt}`
                                        ]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'B',
                        columns: [
                            {
                                field: `showrooms_${date}`,
                                title: 'Showroom',
                                template: (dt => dataItem => numeral(dataItem[`showrooms_${dt}`]).format('0,0[.]00'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][
                                        `showrooms_${dt}`
                                        ]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'C',
                        columns: [
                            {
                                field: `car_services_${date}`,
                                title: translate('Common.Services'),
                                template: (dt => dataItem =>
                                    numeral(dataItem[`car_services_${dt}`]).format('0,0[.]00'))(date),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][
                                        `car_services_${dt}`
                                        ]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'D = A+B+C',
                        columns: [
                            {
                                field: `outlets_${date}`,
                                title: translate('Common.TotalStores'),
                                template: (dt => dataItem => numeral(dataItem[`outlets_${dt}`]).format('0,0[.]00'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][`outlets_${dt}`]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'E',
                        columns: [
                            {
                                field: `groups_${date}`,
                                title: translate('Common.Groups'),
                                template: (dt => dataItem => numeral(dataItem[`groups_${dt}`]).format('0,0[.]00'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][`groups_${dt}`]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'F',
                        columns: [
                            {
                                field: `volume_${date}`,
                                title: 'Emplac.',
                                template: (dt => dataItem => numeral(dataItem[`volume_${dt}`]).format('0,0[.]00'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][`volume_${dt}`]
                                    ).format('0,0[.]00'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'G = F/(A+B)',
                        columns: [
                            {
                                field: `sales_efficiency_${date}`,
                                title: 'Emplac./Loja',
                                template: (dt => dataItem => numeral(dataItem[`sales_efficiency_${dt}`]).format('0,0'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][
                                        `sales_efficiency_${dt}`
                                        ]
                                    ).format('0,0'))(date),
                                width: 80
                            }
                        ]
                    },
                    {
                        title: 'Market Share (%)',
                        columns: [
                            {
                                field: `area_${date}`,
                                title: translate('Common.Area'),
                                template: (dt => dataItem => numeral(dataItem[`area_${dt}`]).format('0[.]0%'))(date),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][`area_${dt}`]
                                    ).format('0[.]0%'))(date),
                                width: 80
                            },
                            {
                                field: `national_${date}`,
                                title: translate('Common.National'),
                                template: (dt => dataItem => numeral(dataItem[`national_${dt}`]).format('0[.]0%'))(
                                    date
                                ),
                                footerTemplate: (dt => () =>
                                    numeral(
                                        _.filter(data.values, d => _.upperCase(d.brand) === 'TOTAL')[0][
                                        `national_${dt}`
                                        ]
                                    ).format('0[.]0%'))(date),
                                width: 80
                            }
                        ]
                    }
                ]
            }))
        );

        return output;
    }
};

export default reducers;



// WEBPACK FOOTER //
// ./src/scripts/api/endpoints/summary/reducers.js